import { UserRole } from '@brickup/shared/enums'
import { ACCOUNT_ROUTE, INTERNAL_ACCOUNT_ROUTE } from '@/constants/routes'
import { useIsShadowView } from '@/contexts/shadow-context'
import { selectUserRoles, useAppStore } from '@/stores/use-app-store'

/**
 * Where the account entry leads, or `null` when it must not be offered.
 *
 * The shadow view has no account screen, and the advisor's own account is the
 * wrong answer while wearing the customer's chrome — so the entry is dropped
 * there rather than pointed somewhere plausible.
 */
export function useAccountHref(): string | null {
  const userRoles = useAppStore(selectUserRoles)
  const isShadowView = useIsShadowView()
  if (isShadowView) return null
  return userRoles?.includes(UserRole.CUSTOMER)
    ? ACCOUNT_ROUTE
    : INTERNAL_ACCOUNT_ROUTE
}
